export const handleDateFormat = (sDate) => {
    sDate = new Date(sDate)
    const month = String(sDate.getMonth() +1).padStart(2, '0')
    const day = String(sDate.getDate()).padStart(2, '0')
    const year = sDate.getFullYear();
    return `${year}-${month}-${day}`;
    // return `${month}-${day}-${year}`
}